import { useState } from "react";
import useDirtyChecker from "../../../hooks/useDirtyChecker";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import { toastSuccess } from "../../../utils/toastUtils";
import GenericActionBar from "../../../Layouts/GenericActionBar/GenericActionBar";
import CodeEditor from "../../../components/BuilderComponents/CodeEditor/CodeEditor";

const AiAssistantEditor = ({ file, templateData, setTemplateData }) => {
  const [isSaving, setIsSaving] = useState(false);
  const { isDirty, markClean } = useDirtyChecker(templateData);

  const handleSave = async () => {
    try {
      const payload = {
        ...templateData,
        name: file?.name
      };

      setIsSaving(true);
      const res = await axiosInstance.patch(`/ai-assistant-template/${file.id}`, payload);
      toastSuccess("Template saved successfully");
      markClean();
      return res.data;
    } catch (err) {
      handleApiError(err);
    } finally {
      setIsSaving(false);
    }
  };

  const handleEditorChange = (jsonString) => {
    try {
      const parsed = JSON.parse(jsonString);
      setTemplateData((prev) => ({ ...prev, ai_variables: parsed }));
    } catch {
      // Invalid JSON - don't update state
    }
  };

  return (
    <div className="d_flex flex_column">
      <GenericActionBar
        path={
          <div>
            <em>AI Assistants</em> → <span>{file.name}</span>
          </div>
        }
        actions={[
          {
            key: "save",
            icon: "save",
            title: isSaving ? "Saving..." : "Save",
            onClick: isSaving ? undefined : handleSave
          }
        ]}
        options={{
          save: {
            className: `${isDirty ? "save_glowing" : ""} ${isSaving ? "disabled" : ""}`.trim()
          }
        }}
      />

      <div className="template_form_outer builder_form">
        <CodeEditor
          language="json"
          value={JSON.stringify(templateData.ai_variables || {}, null, 2)}
          handleChange={handleEditorChange}
          height="500px"
          enableBacktickTrigger={false}
        />
      </div>
    </div>
  );
};

export default AiAssistantEditor;
